import CONTEUDO_PADRAO from "./conteudo-padrao.ts";

export function useConteudo() {
  return CONTEUDO_PADRAO;
}
